module.exports = __webpack_public_path__ + "static/media/135_Courtyard.9d91f8b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_Courtyard.jpg
// module id = 526
// module chunks = 0